import React from "react";
import "../styles/mobileoverallsummary.css";

const MobileOverallSummary = ({
    scoreData,
    attemptData,
    userRank,
    userPercentile,
    accuracy
}) => {

    return (

        <section className="mos-section">

            <h2 className="mos-heading">
                Overall Performance
            </h2>

            <div className="mos-grid">

                <SummaryCard
                    icon="⭐"
                    title="Score"
                    value={scoreData}
                    color="gold"
                />

                <SummaryCard
                    icon="🏆"
                    title="Rank"
                    value={userRank}
                    color="blue"
                />

                <SummaryCard
                    icon="✔"
                    title="Attempted"
                    value={attemptData}
                    color="green"
                />

                <SummaryCard
                    icon="🎯"
                    title="Accuracy"
                    value={`${accuracy}%`}
                    color="pink"
                />

                <SummaryCard
                    icon="📊"
                    title="Percentile"
                    value={`${userPercentile}%`}
                    color="purple"
                    full
                />

            </div>

        </section>

    );

};

function SummaryCard({
    icon,
    title,
    value,
    color,
    full
}){

    return(

        <div className={`mos-card ${color} ${full?"full":""}`}>

            <div className="mos-icon">

                {icon}

            </div>

            <div className="mos-title">

                {title}

            </div>

            <div className="mos-value">

                {value}

            </div>

        </div>

    );

}

export default MobileOverallSummary;